import { Grid, Skeleton } from '@mui/material';

const MobileSkeleton = () => (
    <Grid sx={{ display: 'block', width: '100%' }}>
        <Grid container spacing={1} sx={{ mt: 2, pl: 2, pr: 2 }}>
            {[1, 2, 3, 4, 5].map((section) => (
                <Grid item xs={12} key={section}>
                    {/* Spazio per label */}
                    <Grid item xs={12}>
                        <Skeleton variant="text" width="100%" height={24} />
                    </Grid>
                </Grid>
            ))}
        </Grid>
    </Grid>
);

export default MobileSkeleton;
